// Tiny accessor for the active i18n language without pulling the i18n
// instance into modules that must stay dependency-light.
import i18n from "@/i18n";

export function getDisplayLocale(): string {
  return i18n.language ?? "es";
}
